import React, { Component } from 'react'
import { View, ScrollView, BackHandler, Dimensions } from 'react-native'
// import RNCalendarEvents from 'react-native-calendar-events' // eslint-disable-line import/no-unresolved

import moment from 'moment'
import PropTypes from 'prop-types'

import { VFText, VFButton, VFScreen } from '@vfgroup-oneplatform/foundation/Components'
import SpinnerOverlay from '@vfgroup-oneplatform/foundation/Components/SpinnerOverlay'
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'
import { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView'
import StepperView from '@vfgroup-oneplatform/framework/CommonUI/StepperView'

import BookingSuccessModal from '../../Components/BookingSuccessModal'
import ServiceStep from '../ServiceStep'
import StoreStep from '../StoreStep'
import SummaryStep from '../SummaryStep'
import MeetingStep from '../MeetingStep'
import BookingErrorModal from '../../Components/BookingErrorModal'
import AppointmentCalendar from '../../Components/AppointmentCalendar'

import styles from './BookAnAppointmentSteps.styles'

const appointmentStepsKeys = Object.freeze({
  SERVICE: 'service',
  STORE: 'store',
  DATE: 'date',
})

const steps = activeIndex => ([
  {
    i18nKey: 'book_appointment_service_step_title',
    style: [styles.stepperTitleStyle, activeIndex === 0 && styles.activeTitleTextStyle]
  },
  {
    i18nKey: 'book_appointment_store_step_title',
    style: [styles.stepperTitleStyle, activeIndex === 1 && styles.activeTitleTextStyle]
  },
  {
    i18nKey: 'book_appointment_timeslot_step_title',
    style: [styles.stepperTitleStyle, activeIndex === 2 && styles.activeTitleTextStyle]
  },
  {
    i18nKey: 'book_appointment_summary_step_title',
    style: [styles.stepperTitleStyle, activeIndex === 3 && styles.activeTitleTextStyle]
  },
])

const admin_steps = activeIndex => ([
  {
    i18nKey: 'book_appointment_service_step_title',
    style: [styles.stepperTitleStyle, activeIndex === 0 && styles.activeTitleTextStyle]
  },
  {
    i18nKey: 'book_appointment_meeting_step_title',
    style: [styles.stepperTitleStyle, activeIndex === 1 && styles.activeTitleTextStyle]
  },
  {
    i18nKey: 'book_appointment_timeslot_step_title',
    style: [styles.stepperTitleStyle, activeIndex === 2 && styles.activeTitleTextStyle]
  },
  {
    i18nKey: 'book_appointment_summary_step_title',
    style: [styles.stepperTitleStyle, activeIndex === 3 && styles.activeTitleTextStyle]
  },
])

const CALENDER_PERMISSION_STATUSES = Object.freeze({
  NOT_ASKED: 'undetermined',
  DENIED: 'denied',
  GRANTED: 'authorized',
  RESTRICTED: 'restricted'
})

class BookAnAppointmentSteps extends Component {
  state = {
    activeStep: 0,
    appointment: {},
    isBookingSuccessModalVisible: false,
    isAddedToCalender: false,
    isAddToCalenderDisabled: false,
    selectedDate: '',
    selectedTime: '',
    isBookingErrorModalVisible: false,
  }

  componentDidMount() {
    this.setActiveStepIndex(0)
  }

  componentWillMount() {
    BackHandler.addEventListener('hardwareBackPress', this._onBack)
  }

  componentWillUnmount() {
    BackHandler.removeEventListener('hardwareBackPress', this._onBack)
  }

  onStepPress = index => {
    const { activeStep } = this.state
    if (index < activeStep) {
      this.resetStepsData(index)
      this.setActiveStepIndex(index)
    }
  }

  onServiceItemPress = service => {
    const { onServiceItemPress } = this.props
    this.handleUpdateAppointment(appointmentStepsKeys.SERVICE, service, () => {
      this.setActiveStepIndex(1)
    })
    onServiceItemPress && onServiceItemPress(service)
  }

  onBookAppointmentSuccess = () => {
    if (this.props.bookingAppointmentError) {
      this.setState({ isBookingErrorModalVisible: true })
    } else {
      this.setState({ isBookingSuccessModalVisible: true })
    }
  }

  onBookAppointmentModalClosePress = () => {
    const { onSuccessModalClosePress } = this.props

    this.setState({ isBookingSuccessModalVisible: false })
    onSuccessModalClosePress && onSuccessModalClosePress()
  }

  onBookingErrorModalClose = () => {
    const { onErrorModalClosePress } = this.props

    this.setState({ isBookingErrorModalVisible: false })

    onErrorModalClosePress && onErrorModalClosePress()
  }

  onBookAppointmentModalGoToAppoinmentsPress = () => {
    const { onAppointmentsPress } = this.props

    this.setState({ isBookingSuccessModalVisible: false, isBookingErrorModalVisible: false })

    onAppointmentsPress && onAppointmentsPress()
  }

  onAddToCalenderPress = async appointment => {
    try {
      let permissionStatus = await RNCalendarEvents.checkPermissions()

      if (permissionStatus === CALENDER_PERMISSION_STATUSES.NOT_ASKED || permissionStatus === CALENDER_PERMISSION_STATUSES.RESTRICTED) {
        permissionStatus = await RNCalendarEvents.requestPermissions()
      }

      if (permissionStatus === CALENDER_PERMISSION_STATUSES.GRANTED) {
        const { service, store, date } = appointment

        const selectedTimeStringArr = date?.selectedTime?.split('-')
        const [startHourString, endHourString] = selectedTimeStringArr


        const startHour = parseInt(startHourString, 10)
        const endHour = parseInt(endHourString, 10)


        const startDate = moment(date?.selectedDate).hours(startHour)
        const endDate = moment(date?.selectedDate).hours(endHour)

        let eventDetails = {
          title: service?.title,
          location: `${store?.name}-${store?.address?.name}`,
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
        }

        if (store?.contactInfo) {
          eventDetails = {
            ...eventDetails,
            notes: `${store?.contactInfo?.email} \n ${store?.contactInfo?.phoneNumber}`,
          }
        }

        const eventId = await RNCalendarEvents.saveEvent(service?.title, eventDetails, {})

        this.props?.onAppointemntAddedToCalender && this.props.onAppointmentAddedToCalender(eventId)

        this.setState({ isAddedToCalender: true })
      }
    } catch (_) {
      this.setState({ isAddToCalenderDisabled: true }, () => {
        setTimeout(() => {
          this.setState({ isAddToCalenderDisabled: false })
        }, 5000)
      })
    }
  }

  onDateOrTimeChange = data => {
    this.setState({
      selectedDate: data.selectedDate,
      selectedTime: data.selectedTime,
    })
  }
  resetStepsData = index => {
    const { appointment } = this.state
    switch (index) {
      case 0:
        this.setState({
          appointment: {},
        })
        break
      case 1:
        this.setState({
          appointment: {
            ...appointment,
            [appointmentStepsKeys.DATE]: {},
          },
        })
        break
    }
  }


  setActiveStepIndex = activeStepIndex => {
    const { onActiveStepIndexChange = () => { } } = this.props
    this.setState({
      activeStep: activeStepIndex,
    })
    onActiveStepIndexChange(activeStepIndex, this.state.appointment)
  }

  handleUpdateAppointment = (key, value, onUpdate) => {
    this.setState({ appointment: { ...this.state.appointment, [key]: value } }, onUpdate)
  }
  handleShowTimeSlotsPress = store => {
    this.handleUpdateAppointment(appointmentStepsKeys.STORE, store, () => {
      this.setActiveStepIndex(2)
    })
  }
  handleSelectDateAndTimePress = () => {
    const { selectedDate, selectedTime } = this.state

    this.handleUpdateAppointment(appointmentStepsKeys.DATE, { selectedDate, selectedTime }, () => {
      this.setActiveStepIndex(3)
    })
  }
  handleSelectedMeeting = meeting => {
    this.setState({ appointment: { ...this.state.appointment, [appointmentStepsKeys.STORE]: meeting } })
    this.props.handleSelectedMeeting && this.props.handleSelectedMeeting(meeting)
    this.setActiveStepIndex(2)
  }


  _onBack = () => {
    if (this.state.activeStep === 0) {
      this.props.onBack()
    } else {
      this.onStepPress(this.state.activeStep - 1)
    }
  }

  render() {
    const {
      activeStep,
      appointment,
      isBookingSuccessModalVisible,
      isAddedToCalender,
      isAddToCalenderDisabled,
      isBookingErrorModalVisible,
    } = this.state
    const store = appointment?.store || {}
    const date = appointment?.date || {}
    const {
      isStoresLoading,
      storesData,
      storesError,
      getStoresData,
      getAvailableTimeSlots,
      servicesData,
      isServicesLoading,
      onBookAppointmentPress,
      isBookingAppointmentInProgress,
      formatAppointmentDate,
      withTray,
      isAdmin,
      addressInfo,
      setAddressInfo,
      defaultAppointmentInfo,
      citiesOptions,
      theme = LightThemeColors,
      errorMessage,
      bookingAppointmentError,
      getStoresOpenHours,
      getAppointments,
      onClose,
    } = this.props

    const ScreenWrapper = activeStep === 1 && !isAdmin ? View : ScrollView

    const _steps = activeIndex => {
      if (isAdmin) {
        return admin_steps(activeIndex)
      } else {
        return steps(activeIndex)
      }
    }

    return (
      <VFScreen
        title={isAdmin ? 'book_appointment_title' : 'book_store_appointment_title'}
        onClose={onClose}
        onBack={this._onBack}
        showBack
        headerStyle={{ borderBottomColor: theme.colors.borderColorFour }}
        keyboardShouldPersistTaps='always'
      >
        <View style={styles.container}>
          <StepperView
            steps={_steps(activeStep)}
            activeStep={activeStep}
            onStepPress={this.onStepPress}
            containerStyle={styles.stepperContainerStyle}
            style={styles.stepperStyle}

          />
          <ScreenWrapper
            style={[styles.container, Dimensions.get('window').width > 700 && { paddingHorizontal: '10%' }]}
            contentContainerStyle={styles.container}
            keyboardShouldPersistTaps='always'
          >
            {activeStep === 0 && (
              <ServiceStep
                setActiveStep={activeStepIndex => this.setActiveStepIndex(activeStepIndex)}
                services={servicesData}
                onServiceItemPress={service => this.onServiceItemPress(service)}
                isLoading={isServicesLoading}
                withTray={withTray}
                isAdmin={isAdmin}
              />
            )}
            {activeStep === 1 && !isAdmin && (
              <StoreStep
                isLoading={isStoresLoading}
                stores={storesData}
                onShowTimeSlotsPress={this.handleShowTimeSlotsPress}
                initialSelectedStoreIndex={storesData?.findIndex(storeItem => JSON.stringify(storeItem) === JSON.stringify(store))}
                storesError={storesError}
                getStoresData={getStoresData}
                getStoresOpenHours={getStoresOpenHours}
              />
            )}
            {activeStep === 1 && isAdmin && (
              <MeetingStep
                addressInfo={addressInfo}
                setAddressInfo={setAddressInfo}
                defaultAppointmentInfo={defaultAppointmentInfo}
                handleSelectedMeeting={this.handleSelectedMeeting}
                citiesOptions={citiesOptions}
                isLoading={isStoresLoading}
                error={storesError}
                onTryAgainPress={getStoresData}
                getStoresOpenHours={getStoresOpenHours}
              />
            )}
            {activeStep === 2 && (
              <ScrollView style={{ paddingBottom: 100 }}>
                <VFText
                  i18nKey={'book_appointment_timeslot_step_subtile'}
                  style={styles.titleStyle(theme)}
                />
                <View style={styles.cardStyle(theme)}>
                  <AppointmentCalendar
                    theme={theme}
                    onDateOrTimeChange={this.onDateOrTimeChange}
                    {...date}
                    getAvailableTimeSlots={getAvailableTimeSlots}
                    store={store}
                    getAppointments={getAppointments}
                  />
                  <View style={styles.dividerStyle(theme)} />
                  <VFButton
                    title={'book_appointment_date_cta_button_title'}
                    style={styles.buttonStyle}
                    disabled={!this.state?.selectedDate || !this.state?.selectedTime}
                    onPress={this.handleSelectDateAndTimePress}
                    disabledStyle={styles.disabledButtonStyle(theme)}
                    disabledTextStyle={styles.disabledButtonTextStyle(theme)}
                  />
                </View>
              </ScrollView>
            )}
            {activeStep === 3 && (
              <SummaryStep
                {...this.state.appointment}
                onBookAppointmentPress={onBookAppointmentPress}
                formatAppointmentDate={formatAppointmentDate}
                withTray={withTray}
              />
            )}

          </ScreenWrapper>

          <SpinnerOverlay
            isVisible={isBookingAppointmentInProgress}
            autoPlay
            loop
            lottieStyle={styles.overlayLottie}
            onModalHide={this.onBookAppointmentSuccess}
            type={LottieTypes.whiteSpinner}
          />

          <BookingSuccessModal
            isVisible={isBookingSuccessModalVisible}
            {...appointment}
            formatAppointmentDate={formatAppointmentDate}
            onClose={this.onBookAppointmentModalClosePress}
            onAppointmentsPress={this.onBookAppointmentModalGoToAppoinmentsPress}
            onAddToCalenderPress={this.onAddToCalenderPress}
            isAddedToCalender={isAddedToCalender}
            isAddToCalenderDisabled={isAddToCalenderDisabled}
          />

          <BookingErrorModal
            isVisible={(isBookingErrorModalVisible)}
            onClose={this.onBookingErrorModalClose}
            errorMessage={errorMessage}
          />
          <BookingErrorModal
            isVisible={bookingAppointmentError}
            onClose={this.onBookingErrorModalClose}
            errorMessage={errorMessage}
          />
        </View>
      </VFScreen>
    )
  }
}
BookAnAppointmentSteps.defaultProps = {
  storesData: []
}

BookAnAppointmentSteps.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  storesData: PropTypes.array,
  isStoresLoading: PropTypes.bool,
  storesError: PropTypes.string,
  getStoresData: PropTypes.func,
  getStoresOpenHours: PropTypes.func,
  onServiceItemPress: PropTypes.func,
  servicesData: PropTypes.arrayOf(PropTypes.object),
  isServicesLoading: PropTypes.bool,
  onActiveStepIndexChange: PropTypes.func,
  getAvailableTimeSlots: PropTypes.func,
  onBookAppointmentPress: PropTypes.func,
  isBookingAppointmentInProgress: PropTypes.bool,
  withTray: PropTypes.bool,
  bookingAppointmentError: PropTypes.bool,
  onSuccessModalClosePress: PropTypes.func,
  formatAppointmentDate: PropTypes.func,
  onAppointmentsPress: PropTypes.func,
  onAppointmentAddedToCalender: PropTypes.func,
  isAdmin: PropTypes.bool,
  defaultAppointmentInfo: PropTypes.object,
  setAddressInfo: PropTypes.func,
  addressInfo: PropTypes.shape({
    city: PropTypes.string,
    street: PropTypes.string,
    buildingNo: PropTypes.string,
  }),
  handleSelectedMeeting: PropTypes.func,
  citiesOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.string
  })),
  errorMessage: PropTypes.string,
  onErrorModalClosePress: PropTypes.func
}

export default BookAnAppointmentSteps
